import videoStatus from 'utils/videoStatusUtils';
import { CountModal } from './Modal';
import { format } from 'date-fns';
import videoTableVisibility from 'utils/videosTableVisibility';

const imageStyle = { width: '23px', height: '28px' };

export const defaultSeriesColumns = [
  {
    field: 'select',
    type: 'expanded',
    with: '63px',
    maxWidth: '63px',
    align: 'left',
  },
  {
    field: 'version',
    label: 'Versão',
    align: 'center',
    render: (value, row) => {
      const status = row?.status;
      let backgroundColor = '#D3D3D3'; // default
      switch (status) {
        case 'PUBLISHED':
          backgroundColor = '#98FB98';
          break;
        case 'DRAFT':
          backgroundColor = '#FFFF8F';
          break;
        case 'FAILED':
        case 'EXPIRED':
        case 'FAILED_UPLOAD':
          backgroundColor = '#FF7F7F';
          break;
        case 'TRANSCODED':
          backgroundColor = '#70b4e8ff';
          break;
        case 'ARCHIVED':
          backgroundColor = '#D3D3D3';
          break;
        default:
          backgroundColor = '#D3D3D3';
      }
      return (
        <div
          style={{
            width: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
          }}>
          <div
            className={
              value === undefined
                ? 'datatable_prevent_click'
                : 'video_datatable_version'
            }
            style={{ backgroundColor: backgroundColor }}>
            {value === undefined ? '-' : value}
          </div>
        </div>
      );
    },
  },

  { field: 'buttons', type: 'actions-series', align: 'center' },
  { field: 'title', label: 'Título', align: 'left' },
  {
    field: 'status',
    label: 'Status',
    render: value => videoStatus?.[value] || '-',
  },

  {
    field: 'videos',
    label: 'N.º vídeos',
    render: (value, row) => (
      <CountModal
        title="Videos Associados"
        description={`A série "${row.title}" é composta pelos seguintes vídeos:`}
        listIcon={
          <img
            src="/img/navbar_cockpit/videos_icon.svg"
            alt="Video associados"
            style={imageStyle}
          />
        }
        list={row.videos?.map(v => {
          v.name = (
            <div className="filtered_content_main">
              <div className="filtered_content_content">{v.video.title}</div>
            </div>
          );
          return v;
        })}
      />
    ),
  },

  {
    field: 'visibility',
    label: 'Visibilidade',
    render: value => videoTableVisibility?.[value] || '-',
  },

  {
    field: 'createdBy',
    label: 'Criado por',
    render: value => value?.name || '-',
  },
  {
    field: 'updatedBy',
    label: 'Editado por ',
    render: value => value?.name || '-',
  },
  {
    field: 'updatedAt',
    label: 'Última atualização',
    render: value =>
      value ? format(new Date(value), 'HH:mm dd/MM/yyyy') : '-',
  },
  {
    field: 'publishedAt',
    label: 'Data da publicação',
    render: value => (value ? format(new Date(value), 'dd/MM/yyyy') : '-'),
  },
  {
    field: 'personalitiesCredits',
    label: 'Crédito (Personalidade)',
    render: (value, row) => (
      <CountModal
        title="Personalidades associadas"
        description={`A série "${row.title}" está associado as seguintes personalidades (Crédito):`}
        listIcon={
          <img
            src="/img/navbar_cockpit/personalidade_icon.svg"
            alt="Personalidades Associadas"
            style={imageStyle}
          />
        }
        list={value}
      />
    ),
  },
  {
    field: 'personalities',
    label: 'Com Quem (Personalidade)',
    render: (value, row) => (
      <CountModal
        title="Personalidades associadas"
        description={`A série "${row.title}" está associado as seguintes personalidades (Com Quem?):`}
        listIcon={
          <img
            src="/img/navbar_cockpit/personalidade_icon.svg"
            alt="Personalidades Associadas"
            style={imageStyle}
          />
        }
        list={value}
      />
    ),
  },
  {
    field: 'keywords',
    label: 'Palavras-Chave',
    render: (value, row) => (
      <CountModal
        title="Palavras-Chave associadas"
        description={`A série "${row.title}" está associado as seguintes palavras-chave:`}
        listIcon={
          <img
            src="/img/navbar_cockpit/palavras_chave_icon.svg"
            alt="Palavras-chave Associadas"
            style={imageStyle}
          />
        }
        list={value?.map(v => {
          v.name = (
            <div className="filtered_content_main">
              <div className="filtered_content_title">{v.key}: </div>
              <div className="filtered_content_content">({v.value})</div>
            </div>
          );
          return v;
        })}
      />
    ),
  },

  {
    field: 'units',
    label: 'Unidade',
    render: (value, row) => (
      <CountModal
        title="Unidades associadas"
        description={`A série"${row.title}" está associado as seguintes unidades:`}
        listIcon={
          <img
            src="/img/navbar_cockpit/unidades_sesc_icon.svg"
            alt="Unidades Associadas"
            style={imageStyle}
          />
        }
        list={value}
      />
    ),
  },
  {
    field: 'channels',
    label: 'Canal',
    render: (value, row) => (
      <CountModal
        title="Canais associados"
        description={`A série "${row.title}" está associado aos seguintes canais:`}
        listIcon={
          <img
            src="/img/navbar_cockpit/canais_sesc_icon.svg"
            alt="Canais Associados"
            style={imageStyle}
          />
        }
        list={value}
      />
    ),
  },
];


